var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{staticClass:"text-center error--text my-2"},[_c('v-progress-circular',{staticClass:"me-2",attrs:{"size":20,"width":3,"indeterminate":"","color":"error"}}),_c('strong',[_vm._v("Loading "+_vm._s(_vm.text)+"...")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }